import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import {
  fieldsToGqlString,
  mergeByIdNewAtTop,
} from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const defaultSaiBankCodesFields = {
  _id: '',
  description: '',
  addDeduct: '',
};

export const saiBankCodes = {
  namespaced: true,
  state: () => ({
  }),
  mutations: {
  },
  actions: {
    async loadSaiBankCodesTrans({ commit, dispatch }, {
      criteria, fields, baseCrudKey,
    }) {
      let results;
      const gqlfields = fields || defaultSaiBankCodesFields;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query saiBankCodes($criteria: saiBankCodesCriteriaType) {
            saiBankCodes(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',

        });
        clients.handleGQLErrors(results, commit);
        const bankCodesTrans = results.data ? results.data.saiBankCodes
            || [] : [];
        commit('base/crud/setItems', [baseCrudKey, bankCodesTrans], { root: true });
        return bankCodesTrans;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was problem loading the Transaction List!', { root: true });
      }
      return [];
    },
    async insertReconCode({ commit, dispatch }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation saiBankCodeReconciliation   {
            saiBankCodeReconciliation {
                  result{ok}
                }
              }`,
        });
        results = results.data ? (results.data.saiBankCodeReconciliation || {}).result || {} : {};
        return results;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was problem while inserting Reconciliation Codes!', { root: true });
      }
      return results;
    },
    async upsertSaiBankCodesTrans({ dispatch, rootGetters, commit }, {
      item, fields, baseCrudKey,
    }) {
      let results;
      try {
        const gqlfields = fields || defaultSaiBankCodesFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertSaiBankCodes ($item: saiBankCodesInputType!)  {
                upsertSaiBankCodes(upsert: $item) {
                    ${fieldsToGqlString(gqlfields)},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const bankCodesTransStateData = rootGetters['base/crud/items'](baseCrudKey);
        const newTransaction = results.data ? (results.data.upsertSaiBankCodes
            || {}) : {};
        const newList = mergeByIdNewAtTop(bankCodesTransStateData || [], newTransaction);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
        return newTransaction;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the transaction!', { root: true });
      }
      return {};
    },
    async deleteSaiBankCodesTrans({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteSaiBankCodes ($id: ID!)  {
            deleteSaiBankCodes(id: $id) {
                  _id
                }
              }`,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data ? (results.data.deleteSaiBankCodes || {})._id : null;
        const bankCodesTransData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = bankCodesTransData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
        return delId;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while deleting the transaction!', { root: true });
      }
      return null;
    },
  },
};

export default saiBankCodes;
